import About from '@/app/staticPages/about'

export default About
